import { GameEvent } from './../core/GameAbstract';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import GameTimer from '../core/components/GameTimer';
import GameScore from '../core/components/GameScore';
import Context from 'frontools/core/Context';
import Breakpoint from 'frontools/core/Breakpoint';
import { Food } from './Food';

export class Cavalefringale extends GameAbstract {

    public static instance                  : Cavalefringale;
    private _gameBgColor                    : PIXI.Graphics;
    private _foodContainer                  : PIXI.Container;

    private _food                           : Food;
    private _foods                          : Food[]                        = [];
    private _sound                          : number                        = 0;

    public _tabletBottom                    : PIXI.extras.AnimatedSprite;
    public _tabletTop                       : PIXI.extras.AnimatedSprite;
    
    public _1pinte                          : PIXI.extras.AnimatedSprite;
    public _2pinte                          : PIXI.extras.AnimatedSprite;
    public _3pinte                          : PIXI.extras.AnimatedSprite;
    public _4pinte                          : PIXI.extras.AnimatedSprite;

    public _5pinte                          : PIXI.extras.AnimatedSprite;
    public _6pinte                          : PIXI.extras.AnimatedSprite;
    public _7pinte                          : PIXI.extras.AnimatedSprite;
    public _8pinte                          : PIXI.extras.AnimatedSprite;

    public _pinteIndex                      : number                        = 0;

    public _foodGroup                       : PIXI.Container;
    public _level                           : number;

    private _timeProgress                   : number                        = 0;
    private _generatedTimeOut               : number;

    private _stopFoodCreation               : boolean                       = false;
    private _fromMobile                     : boolean;


    constructor() {
        super({
            time: 30,
            results: [
                '0-49',     //Bas      
                '50-74',    //Moyen
                '75-9999'   //Élevé  
            ],

            assets: [
                { name: 'tabletBottom', url: 'img/tablet.png' },
                { name: 'tabletTop',    url: 'img/tablet.png' },

                { name: '1pinte',       url: 'sprite/milk/1pinte.json' },
                { name: '2pinte',       url: 'sprite/milk/2pinte.json' },
                { name: '3pinte',       url: 'sprite/milk/3pinte.json' },
                { name: '4pinte',       url: 'sprite/milk/4pinte.json' },

                { name: 'cupcake',      url: 'sprite/food/cupcake.json' },
                { name: 'hamburger',    url: 'sprite/food/hamburger.json' },
                { name: 'taco',         url: 'sprite/food/taco.json' },
                { name: 'hotdog',       url: 'sprite/food/hotdog.json' },

                { name: 'chop1',        url: 'audio/chop/chop1.mp3' },
                { name: 'chop2',        url: 'audio/chop/chop2.mp3' },
                { name: 'chop3',        url: 'audio/chop/chop3.mp3' },
                { name: 'chop4',        url: 'audio/chop/chop4.mp3' },
                { name: 'clicked1',     url: 'audio/clicked/clicked1.mp3' },
                { name: 'clicked2',     url: 'audio/clicked/clicked2.mp3' },
                { name: 'clicked3',     url: 'audio/clicked/clicked3.mp3' },
                { name: 'clicked4',     url: 'audio/clicked/clicked4.mp3' },
                { name: 'clicked5',     url: 'audio/clicked/clicked5.mp3' },
                { name: 'clicked6',     url: 'audio/clicked/clicked6.mp3' },
                { name: 'food1',        url: 'audio/food/food1.mp3' },
                { name: 'food2',        url: 'audio/food/food2.mp3' },
                { name: 'food3',        url: 'audio/food/food3.mp3' },
                { name: 'food4',        url: 'audio/food/food4.mp3' },
                { name: 'food5',        url: 'audio/food/food5.mp3' },
                { name: 'food6',        url: 'audio/food/food6.mp3' },
                { name: 'food7',        url: 'audio/food/food7.mp3' },
                { name: 'walk1',        url: 'audio/walk/walk1.mp3' },
                { name: 'walk2',        url: 'audio/walk/walk2.mp3' },
                { name: 'walk3',        url: 'audio/walk/walk3.mp3' },
                { name: 'walk4',        url: 'audio/walk/walk4.mp3' },
                { name: 'walk5',        url: 'audio/walk/walk5.mp3' }
            ]

        });

        // Pseudo singleton
        Cavalefringale.instance = this;
    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();

        this._tabletBottom  = Assets.sprites['tabletBottom'];
        this._tabletTop     = Assets.sprites['tabletTop'];

        this._1pinte        = Assets.sprites['1pinte'];
        this._2pinte        = Assets.sprites['2pinte'];
        this._3pinte        = Assets.sprites['3pinte'];
        this._4pinte        = Assets.sprites['4pinte'];

        this._5pinte        = Assets.getSpriteFromJson('1pinte') as PIXI.extras.AnimatedSprite;
        this._6pinte        = Assets.getSpriteFromJson('2pinte') as PIXI.extras.AnimatedSprite;
        this._7pinte        = Assets.getSpriteFromJson('3pinte') as PIXI.extras.AnimatedSprite;
        this._8pinte        = Assets.getSpriteFromJson('4pinte') as PIXI.extras.AnimatedSprite;

        this._gameBgColor = new PIXI.Graphics();
        this._stage.addChild(this._gameBgColor);
    };

    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {

        if (Breakpoint.isLowerThan('tablet')) this._fromMobile = true;
        else this._fromMobile = false;

        this._resize();
 
        this._foodContainer = new PIXI.Container();
        this._foodContainer.hitArea = new PIXI.Rectangle(0, 0, this._screenWidth, this._screenHeight);
        
        /*
        let graphic:PIXI.Graphics = new PIXI.Graphics();
        graphic.lineStyle(2, 0xFF0000);
        graphic.drawRect(this._1pinte.width / 7, 0, this._1pinte.width / 1.4, this._1pinte.height);
        graphic.endFill();
        this._1pinte.addChild(graphic);
        */

        this._foodContainer.addChild(this._tabletBottom);
        this._tabletBottom.pivot.x =  this._tabletBottom.width / 2;
        this._tabletBottom.pivot.y =  this._tabletBottom.height / 2;
        this._tabletBottom.scale.x = .8;
        this._tabletBottom.scale.y = .5;

        this._foodContainer.addChild(this._tabletTop);
        this._tabletTop.pivot.x =  this._tabletTop.width / 2;
        this._tabletTop.pivot.y =  this._tabletTop.height / 2;
        this._tabletTop.scale.x = .8;
        this._tabletTop.scale.y = .5;

        this._foodGroup = new PIXI.Container();
        this._foodContainer.addChild(this._foodGroup);

        this._foodContainer.addChild(this._1pinte);
        this._1pinte.pivot.x = this._1pinte.width / 2;
        this._1pinte.pivot.y = this._1pinte.height;
        this._1pinte.loop = false;
        this._1pinte.interactive = true;
        this._1pinte.hitArea = new PIXI.Rectangle(this._1pinte.width / 7, 0, this._1pinte.width / 1.4, this._1pinte.height);
        this._1pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._1pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._3pinte);
        this._3pinte.pivot.x = this._3pinte.width / 2;
        this._3pinte.pivot.y = this._3pinte.height;
        this._3pinte.loop = false;
        this._3pinte.interactive = true;
        this._3pinte.hitArea = new PIXI.Rectangle(this._3pinte.width / 6.5, 0, this._3pinte.width / 1.5, this._3pinte.height);
        this._3pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._3pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._2pinte);
        this._2pinte.pivot.x = this._2pinte.width / 2;
        this._2pinte.pivot.y = this._2pinte.height;
        this._2pinte.loop = false;
        this._2pinte.interactive = true;
        this._2pinte.hitArea = new PIXI.Rectangle(this._2pinte.width / 5, 0, this._2pinte.width / 1.7, this._2pinte.height);
        this._2pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._2pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._4pinte);
        this._4pinte.pivot.x = this._4pinte.width / 2;
        this._4pinte.pivot.y = this._4pinte.height;
        this._4pinte.loop = false;
        this._4pinte.interactive = true;
        this._4pinte.hitArea = new PIXI.Rectangle(this._4pinte.width / 6.5, 0, this._4pinte.width / 1.55, this._4pinte.height);
        this._4pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._4pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._5pinte);
        this._5pinte.pivot.x = this._5pinte.width / 2;
        this._5pinte.pivot.y = this._5pinte.height;
        this._5pinte.loop = false;
        this._5pinte.interactive = true;
        this._5pinte.hitArea = new PIXI.Rectangle(this._5pinte.width / 7, 0, this._5pinte.width / 1.4, this._5pinte.height);
        this._5pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._5pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._6pinte);
        this._6pinte.pivot.x = this._6pinte.width / 2;
        this._6pinte.pivot.y = this._6pinte.height;
        this._6pinte.loop = false;
        this._6pinte.interactive = true;
        this._6pinte.hitArea = new PIXI.Rectangle(this._6pinte.width / 5, 0, this._6pinte.width / 1.7, this._6pinte.height);
        this._6pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._6pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._7pinte);
        this._7pinte.pivot.x = this._7pinte.width / 2;
        this._7pinte.pivot.y = this._7pinte.height;
        this._7pinte.loop = false;
        this._7pinte.interactive = true;
        this._7pinte.hitArea = new PIXI.Rectangle(this._7pinte.width / 6.5, 0, this._7pinte.width / 1.5, this._7pinte.height);
        this._7pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._7pinte.on(GameEvent.TAP, this._onClickMilk, this);

        this._foodContainer.addChild(this._8pinte);
        this._8pinte.pivot.x = this._8pinte.width / 2;
        this._8pinte.pivot.y = this._8pinte.height;
        this._8pinte.loop = false;
        this._8pinte.interactive = true;
        this._8pinte.hitArea = new PIXI.Rectangle(this._8pinte.width / 6.5, 0, this._8pinte.width / 1.55, this._8pinte.height);
        this._8pinte.on(GameEvent.CLICK, this._onClickMilk, this);
        this._8pinte.on(GameEvent.TAP, this._onClickMilk, this);
        
        this._stage.addChild(this._foodContainer);
        this._foodContainer.interactive = true;
        this._foodContainer.on(GameEvent.CLICK, this._onClickStage, this);
        this._foodContainer.on(GameEvent.TAP, this._onClickStage, this);

        let ratio = .95;
        if (window.devicePixelRatio > 1) { ratio = this._screenWidth / 225; } 
        
        this._1pinte.scale.x = ratio;
        this._1pinte.scale.y = ratio;

        this._2pinte.scale.x = ratio;
        this._2pinte.scale.y = ratio;

        this._3pinte.scale.x = ratio;
        this._3pinte.scale.y = ratio;

        this._4pinte.scale.x = ratio;
        this._4pinte.scale.y = ratio;


        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 
    };


    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };


    /*
     * @core override
     * _start - Starts the game
     *  
     */
    protected _start() {
        super._start();
        this._generateFoods();
    };


    private _generateFoods() {
        this._createNewFood();
        this._gameTimer.addListener(GameTimer.TIME_CHANGE, function(e) {
             if (e.progress >= 0.93) clearTimeout(this._generatedTimeOut); 
            this._timeProgress = e.progress;
        }.bind(this))
    }


    @autobind
    private _createNewFood() {
        this._level;
        let speed;
        this._sound++;
        if (!this._stopFoodCreation) {
            if(this._timeProgress >= 0) speed = NumberUtils.random(6, 8);
            if(this._timeProgress > 0.2) speed = NumberUtils.random(5, 7);
            if(this._timeProgress > 0.4) speed = NumberUtils.random(4, 6);
            if(this._timeProgress > 0.6) speed = NumberUtils.random(3, 5);
            if(this._timeProgress > 0.8) speed = NumberUtils.random(2, 4);

            this._food = new Food(NumberUtils.random(1, 4), speed, this._sound);

            let whatLevel = NumberUtils.random(1, 2);
            if (whatLevel == 1) this._level = this._tabletBottom.y;
            else this._level = this._tabletTop.y;

            this._foodGroup.addChild(this._food.container);
            this._food.container.x = this._screenWidth;
            this._food.container.y = this._level;

            this._foods.push(this._food);

            this._food.addListener(Food.CLICKED_FOOD, this._onClickFood);
            this._food.addListener(Food.LIMIT_FOOD, this._onReachLimit);

            var timeout = 900 * (1 - this._timeProgress / 1.5);                      // 900 is the default delay when the game start
            this._generatedTimeOut = setTimeout(this._createNewFood, timeout);
        }
    }


    @autobind
    private _onClickFood(e) {
        this._gameScore.add(this._food.score);
    }


    /**
     * Handles clicks on the stage, not on a blood cell.
     * @param e
     */
    private _onClickStage(e) {
        e.stopPropagation();
        //this._gameScore.remove(1);
        //this._milkExpression();
    }

    private _onClickMilk(e) {
        e.stopPropagation();
        e.target.gotoAndPlay(1);
        this._gameScore.remove(1);

        Assets.sounds['clicked' + NumberUtils.random(1, 6)].play();
    }

    @autobind
    private _onReachLimit() {
        this._gameScore.remove(1);
    }


    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        super._onTimerComplete(e);
        this._stopFoodCreation = true;
        this._stopSounds();
        clearTimeout(this._generatedTimeOut);
    };


    private _stopSounds() {
        Assets.sounds['food1'].stop();
        Assets.sounds['food2'].stop();
        Assets.sounds['food3'].stop();
        Assets.sounds['food4'].stop();
        Assets.sounds['food5'].stop();
        Assets.sounds['food6'].stop();
        Assets.sounds['food7'].stop();
        Assets.sounds['walk1'].stop();
        Assets.sounds['walk2'].stop();
        Assets.sounds['walk3'].stop();
        Assets.sounds['walk4'].stop();
        Assets.sounds['walk5'].stop();
    }


    protected _end() {
        super._end();
    }


    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            
            this._gameBgColor.beginFill(0xc8cfd0);
            this._gameBgColor.drawRect(0, 0, this._screenWidth, this._screenHeight);
            this._gameBgColor.endFill();

            this._tabletBottom.x = this._screenWidth / 2;
            this._tabletBottom.y = this._screenHeight / 1.08;

            this._tabletTop.x = this._screenWidth / 2;
            this._tabletTop.y = this._screenHeight / 2.25;

            this._1pinte.x = this._screenWidth / 2 + this._1pinte.width / 1.5;
            this._1pinte.y = this._tabletBottom.y + 10;

            this._3pinte.x = this._screenWidth / 2 - this._3pinte.width / 2.3;
            this._3pinte.y = this._tabletTop.y;

            this._2pinte.x = this._screenWidth / 2 - this._2pinte.width / 1.5;
            this._2pinte.y = this._tabletBottom.y;

            this._4pinte.x = this._screenWidth / 2 + this._4pinte.width / 1.5;
            this._4pinte.y = this._tabletTop.y;
            
            this._5pinte.x = this._4pinte.x + 180; 
            this._5pinte.y = this._tabletTop.y + 10;
            this._5pinte.scale.x = -1;

            this._6pinte.x = this._1pinte.x + 180;
            this._6pinte.y = this._tabletBottom.y;

            this._7pinte.x = this._2pinte.x - 200;
            this._7pinte.y = this._tabletBottom.y;
            this._7pinte.scale.x = -1;

            this._8pinte.x = this._3pinte.x - 200;
            this._8pinte.y = this._tabletTop.y;
            

            if (!this._fromMobile) {
                this._fromMobile = true;
                for (let i = 0; i < this._foods.length; i++) {
                    if(this._foods[i].container.y > 500) this._foods[i].container.y = this._tabletTop.y;
                    else this._foods[i].container.y = this._tabletBottom.y;  
                }
            } 
            if (this._fromMobile) {
                this._fromMobile = false;
                for (let i = 0; i < this._foods.length; i++) {
                    if(this._foods[i].container.y > 500) this._foods[i].container.y = this._tabletTop.y;
                    else this._foods[i].container.y = this._tabletBottom.y;  
                }
            }
        }
    };


    public get screenWidth() : number {
        return this._screenWidth;
    }

    public get foodContainer() : PIXI.Container {
        return this._foodContainer;
    }

}